module.exports = __webpack_public_path__ + "static/media/10n.9dd3a945.png";